import type { TeamLogMessage } from "../types";

/**
 * Generate a concise summary for a message to display when collapsed.
 *
 * Strategy:
 * 1. Strip markdown formatting (headers, bold, code, etc.)
 * 2. Extract first meaningful content line
 * 3. Fallback to track/sprint tag if content is empty
 * 4. Truncate to 120 characters (Track UI-C spec)
 */
export function generateSummary(message: TeamLogMessage): string {
  const tagSummary = message.tags?.find(t =>
    t.startsWith("track:") || t.startsWith("sprint:")
  );

  const lines = message.content
    .split("\n")
    .map(l =>
      l
        .replace(/^[#\-*_`>]+\s*/, "")
        .replace(/\*\*([^*]+)\*\*/g, "$1")
        .replace(/__([^_]+)__/g, "$1")
        .replace(/`([^`]+)`/g, "$1")
        .trim()
    )
    .filter(l => l.length > 0 && !l.match(/^[-=]{3,}$/));

  const firstLine = lines[0] || tagSummary || "No summary available";

  if (firstLine.length <= 120) return firstLine;
  return firstLine.slice(0, 117) + "...";
}
